import React from 'react';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { arrayOf, string } from 'prop-types';
import classNames from 'classnames';
import { Avatar, ReviewRating, UserDisplayName, IconCheckmark, IconCollection } from '../../components';
import { propTypes } from '../../util/types';

import css from './Reviews.module.css';
import { isEmptyReview } from '../../util/data';

const Review = props => {
  const { review, intl } = props;
  const author = review.author;
  const isVerified = author?.attributes?.emailVerified;
  const memberSince = author?.attributes?.createdAt
    ? intl.formatDate(new Date(author.attributes.createdAt), { year: 'numeric' })
    : null;
  const date = review.attributes.createdAt;
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });

  return (<div>

    <div className={css.review}>
      <div className={css.avatarCol}>
        <Avatar className={css.avatar} user={author} />
      </div>
      <div className={css.contentCol}>
        <div className={css.topRow}>
          <span className={css.displayName}><UserDisplayName user={author} intl={intl} /></span>
          {isVerified && (
            <span className={css.verifiedBadge}><IconCollection name="profile_varified"/> Verified</span>
          )}
        </div>
        {memberSince && (
          <div className={css.memberSince}>Member since {memberSince}</div>
        )}

      </div>
    </div>
    <div className={css.starsRow}>
      <ReviewRating
        rating={review.attributes.rating}
        className={css.reviewStars}
        reviewStarClassName={css.reviewRatingStar}
      />
    </div>
    <div className={css.reviewContent}>{isEmptyReview(review.attributes.content) ? '' : review.attributes.content}</div>
  </div>
  );
};

Review.propTypes = {
  review: propTypes.review.isRequired,
  intl: intlShape.isRequired,
};

const ReviewsComponent = props => {
  const { className, rootClassName, reviews, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <ul className={classes}>
      {reviews.map(r => {
        return (
          <li key={`Review_${r.id.uuid}`} className={css.reviewItem}>
            <Review review={r} intl={intl} />
          </li>
        );
      })}
    </ul>
  );
};

ReviewsComponent.defaultProps = {
  className: null,
  rootClassName: null,
  reviews: [],
};

ReviewsComponent.propTypes = {
  className: string,
  rootCalssName: string,
  reviews: arrayOf(propTypes.review),

  // from injectIntl
  intl: intlShape.isRequired,
};

const Reviews = injectIntl(ReviewsComponent);

export default Reviews;
